import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IComponentState } from '@models/index';

export const componentsSelector = createFeatureSelector<IComponentState>('components');
export const getSavingSelector = createSelector(componentsSelector, (state: IComponentState) => state.saved); 
export const getLoadingSelector = createSelector(componentsSelector, (state: IComponentState) => state.loader);
